export default function SubmitButton({ buttonText, buttonValue, disabled = false, loading = false }) {
  return (
    <button
      className="btn fw-bold mb-2 bg-main-purple w-100"
      type="submit"
      value={buttonValue}
      disabled={disabled || loading}
      style={{
        borderRadius: "12px",
        padding: "0.75rem 1rem",
        fontSize: "1rem",
        letterSpacing: "0.02em",
      }}
    >
      {loading ? (
        <span>
          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          Loading...
        </span>
      ) : (
        buttonText
      )}
    </button>
  );
}
